import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedValidateXMLRes } from 'app/interfaces/responses/Exposed/exposedValidateXMLRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { catchError, finalize, map, Observable } from 'rxjs';
import { TranslationService } from '../translation/translation.service';

@Injectable({
    providedIn: 'root',
})
export class XMLValidationService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private translationService: TranslationService,
        private alertsService: AlertsService,
        private router: Router
    ) {}

    public validateXML = (xmlFile: File, schemaFile: File): Observable<ExposedValidateXMLRes> => {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Villuprófa XML skjal');

        var body = new FormData();
        body.append('XmlFile', xmlFile, 'XmlFile');
        body.append('SchemaFile', schemaFile, 'SchemaFile');

        return this.http
            .post(environment.localApi + 'XMLValidation/validate', body, this.httpRequestHelper.getRequestOptionsAuthFileUpload())
            .pipe(
                map((res: HttpStatus<ExposedValidateXMLRes>) => res.returnItem),
                catchError((error) => {
                    HttpError(this.alertsService, this.router, error, '', '', '', '');
                    throw error;
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );
    };
}
